import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, MissionPageContainer } from "../../common_components/Layout";
import SubHeader from "../SubHeader";
import { SessionHighlightUpcoming } from "../../common_components/SessionHighlights";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";


// Api Calls
import MissionUserListAPI from "../../../api/api_calls/MissionUserListsAPI";


function UpcomingSessions(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId, sessionId } = useParams()
    const [screenerJson, setScreenerJson] = useState({});
    const [loading, setLoading] = useState(true);
    const appId = props.mission_user_list_id;




    useEffect(() => {
        async function getScreenerResponse() {
            const result = await MissionUserListAPI.show_screener_response({ missionId, mission_user_list_id: appId, handleRedirect: navigate });

            if (result.success) {
                setScreenerJson(result.screener_response)
                setLoading(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getScreenerResponse();
    }, []);


    return (
        <Card >
            <GrayCardTitle title="Screener Responses" />
            {loading ? <CenteredLoadingIcon /> : <ScreenerResponses screenerJson={screenerJson} />}
        </Card>
    )
}


function ScreenerResponses(props) {
    console.log(props.screenerJson)

    // Example format:  
    // We're going to map this into a list of questions and answers. 
    // The questions will be the keys, and the answers will be the values.
    // We'll need to handle multiple answers for a single question.
    //{
    //     "Which apps have you used for investments in the last 12 months? \n(Please do NOT include apps that you only use for retirement accounts like 401k’s or IRAs)": [
    //         "Robinhood",
    //         "Fidelity"
    //     ],
    //     "Please provide a link to your portfolio (NFT, Art, or otherwise).": [
    //         "https://asdasd.asd"
    //     ],
    //     "Do you currently identify as a Digital Creator (Art, NFTs, 3D Models, etc.)?": [
    //         "Yes"
    //     ],
    //     "Please indicate if you agree or disagree with the following statements": {
    //         "Product is affordable": [
    //             "Neutral"
    //         ],
    //         "Product does what it claims": [
    //             "Agree"
    //         ],
    //         "Product is better than other products on the market": [
    //             "Agree"
    //         ],
    //         "Product is easy to use": [
    //             "Agree"
    //         ]
    //     }
    // }

    return (
        <div className="screener-response-div">
            {Object.keys(props.screenerJson).map((question, index) => {
                return (
                    <div key={index} className="screener-question">
                        <div className="screener-question-text">
                            {question}
                        </div>
                        <div className="screener-answer-padding">
                            <div className="screener-answer-container">
                                <ScreenerAnswer key={question + index} answer={props.screenerJson[question]} />
                            </div>
                        </div>
                    </div>
                )
            }
            )}
        </div>
    )
}

function ScreenerAnswer(props) {

    function AnswerBullet(partial_answer, index) {
        if (partial_answer["paste_data"] && partial_answer["paste_data"]["pasted"]) {
            return (
                <li key={index} className="screener-answer-bullet">
                    <span className="screener-paste-note">This response contains copy/pasted text: "{partial_answer["paste_data"]["paste_text"]}" </span><br />{partial_answer["response_text"]}
                </li>
            )
        } else {
            return (
                <li key={index} className="screener-answer-bullet">
                    {partial_answer["response_text"]}
                </li>
            )
        }
    }


    if (Array.isArray(props.answer)) {
        return (
            <ul className="screener-answer-list">
                {props.answer.map((answer, index) => {
                    return AnswerBullet(answer, index);
                }
                )}
            </ul>
        )
    } else if (props.answer === null) {
        return (
            <ul className="screener-answer-list">
                <li className="screener-answer-bullet">
                    No response
                </li>
            </ul>
        )
    } else if (typeof props.answer === "object") {
        return (
            <ul className="screener-answer-list">
                {Object.keys(props.answer).map((question, index) => {
                    return (
                        <li key={question + index} className="screener-answer-bullet subquestion">
                            {question}
                            <ul className="screener-subquestion-list">
                                {props.answer[question].map((subAnswer, subindex) => {
                                    {/* This mimics the format of the array return above */ }
                                    return AnswerBullet(subAnswer, question + index + subindex);
                                })}
                            </ul>
                        </li>
                    )
                }
                )}
            </ul>
        )

    } else {
        return (
            <ul className="screener-answer-list">
                <li className="screener-answer-bullet">
                    {props.answer["response_text"]}
                </li>
            </ul>

        )
    }


}



export default UpcomingSessions;